<div class="all-pages">
    <div class="container page" >
        <h2>Cupones de pago <button style="float: right;" class="btn btn-primary" (click)="downloadAsPDF()">Exportar a PDF</button></h2> 
        <div class="paySlip" #paySlip *ngFor="let page of pages">
    
          <div class="slip" *ngFor="let slip of page.slips">
            <div class="row">
                <div class="col-3 ">
                    <div class="border">
                        PAGO#<br/>
                        {{ slip.installmentNumber }}
                    </div>
                    
                </div>
                <div class="col-1">
                    
                </div>
                <div class="col-2">
                    <div class="border">
                        PAGO NUMERO<br/>
                        {{ slip.installmentNumber }}
                    </div>
                </div>
                <div class="col-2">
                    <div class="border">
                        NUMERO CONTRATO<br/>
                        {{contractId}}
                    </div>
                    
                </div>
                <div class="col-2">
                    <div class="border">
                        VENCIMIENTO<br/>
                        {{ slip.installmentDate | date: 'shortDate' }}
                    </div>
                    
                </div>
                <div class="col-2">
                    <div class="border">
                        PAGO<br/>
                        {{ slip.installmentAmount | currency }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <div class="border">
                        VENCIMIENTO<br/>
                        {{ slip.installmentDate | date: 'shortDate' }}
                    </div>
                    
                </div>
                <div class="col-1">
                    
                </div>
                <div class="col-2">
                    
                </div>
                <div class="col-2">
                    
                </div>
                <div class="col-2">
                    <div class="border">
                        FECHA ATRASO<br/>
                        {{ slip.expDate | date: 'shortDate' }}
                    </div>
                </div>
                <div class="col-2">
                    <div class="border">
                        INCLUYA RECARGO<br/>
                        {{ slip.recargo | currency }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <div class="border">
                        BALANCE DESPUES DE PAGO<br/>
                        {{ slip.thisEndingBalance | currency }}
                    </div>
                </div>
                <div class="col-1">
                    
                </div>
                <div class="col-2">
                    
                </div>
                <div class="col-2">
                    
                </div>
                <div class="col-2">
                    
                </div>
                <div class="col-2">
                    <div class="border">
                        CON RECARGO<br/>
                        {{slip.recargoPaymentAmount | currency}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <div class="border">
                        SU NUMERO DE CHEQUE<br/><br/>
                        ___________________
                    </div>
                </div>
                <div class="col-1">
                    
                </div>
                <div class="col-4">
                    <div class="border">
                        <strong>{{contract.insName}}</strong><br>
                        {{ contract.postalAddress1 }}, {{ contract.postalAddress2 }}<br>
                        {{ contract.postalCity }} {{ contract.postalState }} {{ contract.postalZip }}
                    </div>
                    
                </div>
                <div class="col-4" style="padding: 5px;">
                    <strong>Central Credit Corp</strong><br>
                    PO BOX 361958<br>
                    San Juan PR 00936-1958
                </div>
            </div>
            <div class="row">
                <div class="col-2">
    
                </div>
                <div class="col-2">
                    
                </div>
                <div class="col-8" style="padding: 10px 0px 10px 10px">
                    ESCRIBA SU NUMERO DE CUENTA AQUÍ: _____________________________________
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" style="font-size: 16px; text-align: center;">
                    NO USE ESTE CUPON PARA PAGAR EN EL BANCO. SOLO PARA PAGAR EN NUESTRA OFICINA.
                </div>
            </div>
          </div>
        </div>
        
      </div>
          
    </div>
    